import { render, staticRenderFns } from "./WorkUploadZone.vue?vue&type=template&id=6c36c3bd&scoped=true"
import script from "./WorkUploadZone.vue?vue&type=script&lang=js"
export * from "./WorkUploadZone.vue?vue&type=script&lang=js"
import style0 from "./WorkUploadZone.vue?vue&type=style&index=0&id=6c36c3bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c36c3bd",
  null
  
)

export default component.exports